import { ReactNode, useState } from "react";

import { createRollForwardWizardStore, RollForwardWizardStoreContext } from "./roll_forward_wizard_store";
import { RollForwardWizardInitialState } from "./roll_forward_wizard_store_types";

type RollForwardWizardStoreProviderProps = {
  children: ReactNode;
  initialState?: RollForwardWizardInitialState;
};

export const RollForwardWizardStoreProvider = ({
  children,
  initialState
}: RollForwardWizardStoreProviderProps) => {
  const [store] = useState(() => createRollForwardWizardStore(initialState));

  return (
    <RollForwardWizardStoreContext.Provider value={store}>{children}</RollForwardWizardStoreContext.Provider>
  );
};
